/** Vista "Programa de instalaciones" — formato Excel: filas = cuadrilla, columnas = días. */
import React from 'react';
import api from '@/api/axios';
import { toast } from 'sonner';
import { Printer } from '@phosphor-icons/react';

const DIAS = ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'];

const cuadrillaDe = (it) => {
  const ns = (it.instaladores || []).map((x) => x.nombre).filter(Boolean);
  return ns.join(' / ') || it.instalador_responsable_nombre || it.operador_nombre || 'Sin asignar';
};

export default function ProgramaSemanal({ items, weekStart, business, onEdit }) {
  const fechas = [...Array(7)].map((_, i) => {
    const d = new Date(weekStart + 'T00:00:00');
    d.setDate(d.getDate() + i);
    return d;
  });
  const iso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
  const grupos = {};
  items.forEach((it) => { const k = cuadrillaDe(it); (grupos[k] = grupos[k] || []).push(it); });
  const cuadrillas = Object.keys(grupos).sort();
  const fmt = (d) => d.toLocaleDateString('es-GT', { day: '2-digit', month: '2-digit', year: 'numeric' });

  const pdf = async () => {
    try {
      const r = await api.get('/programacion/programa-semanal/pdf', {
        params: { week_start: weekStart, business_id: business?.id }, responseType: 'blob',
      });
      const u = URL.createObjectURL(r.data);
      const a = document.createElement('a');
      a.href = u; a.download = `programa_semana_${weekStart}.pdf`; a.click();
      URL.revokeObjectURL(u);
    } catch { toast.error('No se pudo generar el PDF'); }
  };

  return (
    <div className="bg-[var(--surface)] border border-[var(--border)] rounded-md overflow-hidden" data-testid="programa-semanal">
      <div className="flex flex-wrap items-center justify-between gap-2 px-3 py-2 border-b border-[var(--border)]">
        <p className="text-sm font-black text-[var(--text)] uppercase" data-testid="programa-titulo">
          Programa de instalaciones — semana {fmt(fechas[0])} a {fmt(fechas[6])}
        </p>
        <button onClick={pdf} className="px-3 py-1.5 bg-purple-600/10 border border-purple-600/30 text-purple-700 dark:text-purple-300 hover:bg-purple-600/20 rounded-md text-xs font-bold flex items-center gap-1" data-testid="programa-pdf">
          <Printer size={13} /> Imprimir PDF
        </button>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-xs border-collapse min-w-[1000px]">
          <thead>
            <tr>
              <th className="border border-[var(--border)] bg-[var(--surface-muted)] px-2 py-2 text-[10px] uppercase font-black text-[var(--text-muted)] w-[130px]">Cuadrilla</th>
              {DIAS.map((d, i) => (
                <th key={d} className="border border-[var(--border)] bg-[var(--surface-muted)] px-2 py-2 text-[10px] uppercase font-black text-[var(--text-muted)]">
                  {d}<br /><span className="font-bold text-[var(--text-faint)]">{fechas[i].toLocaleDateString('es-GT', { day: '2-digit', month: '2-digit' })}</span>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {cuadrillas.length === 0 ? (
              <tr><td colSpan={8} className="border border-[var(--border)] py-8 text-center text-[var(--text-muted)] italic">Sin programaciones esta semana.</td></tr>
            ) : cuadrillas.map((cuad) => (
              <tr key={cuad} data-testid={`programa-fila-${cuad}`}>
                <td className="border border-[var(--border)] bg-[var(--surface-muted)]/60 px-2 py-2 text-center font-black text-[var(--text)] text-[11px]">{cuad}</td>
                {fechas.map((f) => {
                  const fiso = iso(f);
                  const dia = grupos[cuad].filter((it) => (it.fecha_inicio || '').slice(0, 10) <= fiso && fiso <= (it.fecha_fin || it.fecha_inicio || '').slice(0, 10));
                  return (
                    <td key={fiso} className="border border-[var(--border)] px-1.5 py-1.5 align-top">
                      <div className="space-y-1.5">
                        {dia.map((it) => (
                          <button key={it.id || `${it.ot_numero}-${fiso}`} type="button" onClick={() => onEdit && it.id && onEdit(it)}
                            className="w-full text-center hover:bg-purple-500/10 rounded p-0.5" data-testid={`programa-cell-${it.id}-${fiso}`}>
                            {it.ot_numero && <p className="text-[10px] font-black text-red-600">OT {it.ot_numero}</p>}
                            {it.descripcion_trabajo && <p className="text-[10px] text-[var(--text)] leading-tight">{it.descripcion_trabajo}</p>}
                            {it.direccion && <p className="text-[10px] font-bold text-[var(--text)]">{it.direccion}</p>}
                          </button>
                        ))}
                      </div>
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
